import { Component, Inject, OnInit, Renderer2 } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { DOCUMENT } from '@angular/common';
import { isHotjarScriptEnabled } from '../../../utils/feature-flags';

@Component({
  selector: 'app-hot-jar',
  template: '<ng-content></ng-content>',
})
export class HotJarComponent implements OnInit {
  private hotjarProjectId = environment.hotJarProjectId;
  private hotjarScript!: HTMLScriptElement
  isHotjarScriptEnabled = isHotjarScriptEnabled
  constructor(
    private renderer2: Renderer2,
    @Inject(DOCUMENT) private doc: Document
  ) { }

  /**
   * @description OnInit lifecycle hook
   */
  ngOnInit(): void {
    if (this.isHotjarScriptEnabled) {
      this.hotjarScript = this.renderer2.createElement("script");
      this.loadHotjarScript();
    }
  }

  /**
   * @description Load Hotjar script
   */
  loadHotjarScript(): void {
    this.hotjarScript.setAttribute("id", "hotjarScript");
    this.hotjarScript.type = "text/javascript";
    this.hotjarScript.text = `(function(h,o,t,j,a,r){
        h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)};
        h._hjSettings={hjid:${this.hotjarProjectId},hjsv:6};
       a=o.getElementsByTagName('head')[0];
        r=o.createElement('script');r.async=1;
        r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;
        a.appendChild(r);
    })(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=');`;
    this.renderer2.appendChild(this.doc.head, this.hotjarScript);
  }

}
